import { __extends } from "tslib";
import { AbstractRenderer } from '@antv/g';
import * as DomInteraction from '@antv/g-plugin-dom-interaction';
import * as WebGLRenderer from '@antv/g-plugin-webgl-renderer';
import { ContextRegisterPlugin } from './ContextRegisterPlugin';
export { DomInteraction, WebGLRenderer };

var Renderer =
/** @class */
function (_super) {
  __extends(Renderer, _super);

  function Renderer(config) {
    var _this = this;

    var _a;

    _this = _super.call(this, config) || this;

    _this.registerPlugin(new ContextRegisterPlugin());

    _this.renderGraphPlugin = new WebGLRenderer.Plugin((config === null || config === void 0 ? void 0 : config.targets) ? {
      targets: config.targets
    } : {});

    _this.registerPlugin(_this.renderGraphPlugin);

    if (((_a = config === null || config === void 0 ? void 0 : config.plugins) === null || _a === void 0 ? void 0 : _a.enableDOMInteraction) !== false) {
      _this.registerPlugin(new DomInteraction.Plugin());
    }

    return _this;
  }

  Renderer.prototype.getDevice = function () {
    return this.renderGraphPlugin.getDevice();
  };

  Renderer.prototype.loadTexture = function (src, descriptor, successCallback) {
    return this.renderGraphPlugin.loadTexture(src, descriptor, successCallback);
  };

  return Renderer;
}(AbstractRenderer);

export { Renderer };